// ABOUTME: Components used by the ORDER_STATE grouping preset — ShLabel pill keyed by t(state).
// ABOUTME: The registry entry that references these lives in groupingPresets/index.js.

import { Box, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import ShLabel from "../../label/ShLabel";
import { getOrderStateData } from "../../../../utils/labelColorText";
import { getShipperLogo } from "../../../../utils/logomapper";
import Text from "../../text/Text";


export const ShipperLabel = ({ groupKey }) => {
    const { t } = useTranslation();
    const theme = useTheme();
    return (
       <Box
        sx={{
            display:"flex",
            alignItems:'center',
            gap:1.5,
        }}
       >
            {getShipperLogo(groupKey.type)} 
            <Text>
                {groupKey.name}
            </Text>
       </Box>
    );
};

export const ShipperPreview = () => {
    const { t } = useTranslation();
    const theme = useTheme();
    
    return (
        <Box>
            {getShipperLogo("dhl")}
        </Box>
    );
};
